import { Loading, useToggle } from '@commenda/kakashi';
import { motion, useReducedMotion } from 'framer-motion';

import { CommendaLayout } from 'components/Layouts/Layout/CommendaLayout';
import { useConfig } from 'context/useConfig';
import { useOnboardingRedirect } from 'hooks/useOnboardingRedirect';

import { GeneralThreadPanel } from './GeneralThreadPanel';
import { HomeContent } from './HomeContent';
import { HomeTopBar } from './HomeTopBar';

export const NewHomeScreen = () => {
  const { isLoading } = useOnboardingRedirect();
  const { companyId } = useConfig();
  const prefersReducedMotion = useReducedMotion();

  const inboxPanelVisibility = useToggle(false);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen w-full">
        <Loading />
      </div>
    );
  }

  return (
    <CommendaLayout
      aside={
        inboxPanelVisibility.visible && companyId
          ? {
              content: (
                <div className="h-full overflow-hidden">
                  <motion.div
                    className="flex h-full flex-col"
                    initial={prefersReducedMotion ? false : { x: '100%' }}
                    animate={{ x: 0 }}
                    transition={{ type: 'tween', duration: 0.2, ease: 'easeOut' }}
                  >
                    <GeneralThreadPanel companyId={companyId} />
                  </motion.div>
                </div>
              ),
              variant: 'detached',
              width: '400px',
              className: '!bg-transparent !border-0 !shadow-none !rounded-none',
            }
          : undefined
      }
      breadcrumb={
        <HomeTopBar
          isInboxOpen={inboxPanelVisibility.visible}
          onInboxToggle={inboxPanelVisibility.toggle}
        />
      }
      disableContentPadding
    >
      <HomeContent />
    </CommendaLayout>
  );
};
